export function createHTMLElement(tag, ops) {
  let parent = document.getElementById(ops.parent);
  let element = document.createElement(tag);
  !("id" in ops) ? (element.id = "") : (element.id = ops.id);
  !("class" in ops) ? (element.class = "") : (element.className = ops.class);
  !("innerHTML" in ops)
    ? (element.innerHTML = "")
    : (element.innerHTML = ops.innerHTML);
  !("style" in ops) ? (element.style = "") : (element.style = ops.style);
  parent.appendChild(element);
  return element;
}

export function show(element) {
  element.classList.remove("hidden");
}

export function hide(element) {
  element.classList.add("hidden");
}

export function getPlayerLinkFromVimLink(vim_link) {
  // takes this format: `https://vimeo.com/416133368`
  // needs to be updated to take different ones?
  const splitted = vim_link.split("//")[1].split("/");
  const link = `https://player.${splitted[0]}/video/${splitted[1]}?controls=0&amp;app_id=122963`;
  return link;
}

export function calcFontSize(moduleWidth, stringLength) {
  // to-do: apply min/max font-size
  return (moduleWidth / stringLength) * 2; // random but seems to work for now
}

export function calcLongestString(aListOfStrings) {
  return Math.max.apply(null, aListOfStrings);
}

export function isOrientationLandscape() {
  return window.matchMedia("(orientation: landscape)").matches;
}

export function clamp(num, min, max) {
  return [num, min, max].sort((a, b) => a - b)[1];
}

export function showOrientationAlert(show = true) {
  const prompt = document.querySelector(".prompt__landscape-mode");
  show
    ? prompt.classList.add("prompt__landscape-mode--enabled")
    : prompt.classList.remove("prompt__landscape-mode--enabled");
}

function shortenDate(d) {
  const date = new Date(d);
  const month = ("" + parseInt(date.getMonth() + 1)).padStart(2, "0");
  return `${month}/${date.getFullYear()}`;
}

export function isMobile() {
  return !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

// Used for taking a subtitle, seeing if it parses as text.
// If it does, render appropriately, based on device type
export function dateOrText(t) {
  if (isNaN(Date.parse(t)) || !isMobile()) return t;
  return shortenDate(t);
}

// Checks if current website content is in an iframe
export function isWindowInIframe() {
  return window.location !== window.parent.location;
}
